module.exports = __webpack_public_path__ + "img/abp_icon-1.32014d3c.svg";